import { makeStyles } from '@material-ui/core/styles';

export const reportItemStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  name: {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginLeft: theme.spacing(1)
  }
}));
